<template>
    <dialog-component
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      :pressClick="false"
      :showClose="showClose"
      @dialogClose="closeChangePassword"
      dialog-title="安全检测"
      width="42%">
      <div slot="content" style="padding: 20px 30px;min-height: 28vh;">
        <el-row style="color: rgba(216,228,106,1);margin-bottom: 40px;">{{text}}
        </el-row>
        <el-form :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="100px" ref="ruleForm" status-icon>

          <el-form-item label="原密码：" prop="originalPass">
            <el-input autocomplete="off" class="input-width" size="mini" type="password"
                      v-model="ruleForm.originalPass"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="pass" style="margin-bottom: 10px;">
            <el-input autocomplete="off" class="input-width" size="mini" type="password"
                      v-model="ruleForm.pass"></el-input>
            <span :class="safetyLevel === 0 ? 'red':''" class="passwordCheck" style="margin-left: 10px;">低</span>
            <span :class="safetyLevel === 1 ? 'brown':''" class="passwordCheck">中</span>
            <span :class="safetyLevel === 2 ? 'green':''" class="passwordCheck">高</span>
            <span style="margin-left: 10px;">安全强度：
              <span class="name red" v-if="safetyLevel === 0">低</span>
              <span class="name brown" v-if="safetyLevel === 1">中</span>
              <span class="name green" v-if="safetyLevel === 2">高</span>
            </span>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPass">
            <el-input autocomplete="off" class="input-width" size="mini" type="password"
                      v-model="ruleForm.checkPass"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center;margin-bottom: 20px;">
        <el-button @touchstart="submitForm('ruleForm')"  @click="submitForm('ruleForm')" size="mini" type="primary">确认</el-button>
      </div>
    </dialog-component>
</template>

<script>
import DialogComponent from "@/components/DialogComponent";
import {modifyPassword, verifyPwLevel} from "@/network/account";

export default {
  name: "ChangePassword",
  components: {DialogComponent},
  props:["text","dialogVisible","showClose"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        verifyPwLevel(value).then(res => {
          this.safetyLevel = res.data
        })
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        originalPass: '',
        pass: '',
        checkPass: '',
      },
      rules: {
        pass: [
          {validator: validatePass, trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      },
      safetyLevel: 0,
    }
  },
  methods: {
    // 提交表单 修改密码
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        // console.log("修改密码表单：", valid);
        if (valid) {
          modifyPassword(this.ruleForm.originalPass, this.ruleForm.checkPass).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '修改密码成功',
                type: 'success'
              });
              this.$emit('closeChangePassword');
            } else {
              this.$message.error('修改密码失败: ' + res.message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeChangePassword(){
      this.$emit('closeChangePassword');
    }
  }
}
</script>

<style scoped>

</style>
